import { getRegionList } from '@/service/webClientService';
import { SDLUtil, RequestUtil, StringUtil } from '@/utils';

export default {
  // async GET_PROJECT_LIST(store) {
  //   const res = await getProjectListFromAPI();
  //   // store.commit('setProjectList', res.data.rsp.SvcDetails);
  // },
  async GET_REGION_LIST(store, mchnToken) {
    const res = await getRegionList(mchnToken);
    store.commit('setRegionList', res.data);
  },

  async getStorageAccountList(store, params) {
    const res = await RequestUtil.get(
      `${SDLUtil.API_URL}/webclient/resource/${params.project_uid}/${params.env}/${params.csp_cd}/${params.rsrc_type}`,
    );

    store.commit('setStorageAccountList', res.data.data);
  },

  async getStorageAccountToken(store, params) {
    const res = await RequestUtil.get(
      `${SDLUtil.API_URL}/webclient/resource/token/${params.accountId}/${params.csp_cd}/${
        params.rsrc_type
      }?${StringUtil.queryStringfy(params)}`,
    );

    store.commit('addStorageAccountConn', res.data.data);
  },

  async getAllowIp(store, params) {
    const res = await RequestUtil.get(
      `${SDLUtil.API_URL}/webclient/resource/allowip/${params.csp_cd}?${StringUtil.queryStringfy(params)}`,
    );

    store.commit('setStorageAccountIpList', res.data.data);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/webClient/webClientAction.js